import PostBox from "../../components/PostBox/PostBox";
import { ReactComponent as ArrowLeft } from "../../icons/arrow-left.svg";
import { useHistory } from "react-router-dom";
import { useModal } from "../../hooks/useModal";
import { useAppSelector } from "../../hooks/useReduxToolkit";
import Modal from "../../components/Modal";
import styled from "styled-components";
import copy from "copy-to-clipboard";
import { ContentItem } from "./Creator";
import { useEffect, useMemo, useRef, useState } from "react";

interface Props {
  onClickBack: () => void;
  onClickStartOver: () => void;
  onClickFinish: () => void;
  onClickCustomTemplates: () => void;
  updateEditedContent: (text: string) => void;
  category: string;
  data: ContentItem[];
}

export const TEXT = `<h2><strong>Lorem ipsum dolor sit amet,</strong></h2><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi.&nbsp;</p><p><br></p><p>Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue.&nbsp;</p><p><br></p><p>Vestibulum auctor ornare leo, non suscipit magna interdum eu.&nbsp;</p><p><br></p><p><br></p><h2><strong>Lorem ipsum dolor sit amet,</strong></h2><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p><p><br></p><p><br></p><p><br></p><p><br></p><h2><strong>Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et</strong></h2><p><br></p><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi.&nbsp;</p><p><br></p><p>Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue.&nbsp;</p><p><br></p><p>Vestibulum auctor ornare leo, non suscipit magna interdum eu.&nbsp;</p><p><br></p><p><br></p><p><br></p><h3>Lorem ipsum dolor sit amet,</h3><p><br></p><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p><p><br></p><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p><p><br></p><p><br></p><h2>Lorem ipsum dolor sit amet,</h2><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi.&nbsp;</p><p><br></p><p>Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue.&nbsp;</p><p><br></p><p>Vestibulum auctor ornare leo, non suscipit magna interdum eu.&nbsp;</p><p><br></p><p><br></p><h2>Lorem ipsum dolor sit amet,</h2><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p><p><br></p><p><br></p><p><br></p><p><br></p><h2>Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et</h2><p><br></p><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi.&nbsp;</p><p><br></p><p>Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue.&nbsp;</p><p><br></p><p>Vestibulum auctor ornare leo, non suscipit magna interdum eu.&nbsp;</p><p><br></p><p><br></p><p><br></p><h3>Lorem ipsum dolor sit amet,</h3><p><br></p><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p><p><br></p><p><br></p><p>Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla,</p>`;

export default function GenerateStep({
  onClickBack,
  onClickStartOver,
  updateEditedContent,
  onClickFinish,
  onClickCustomTemplates,
  category,
  data,
}: Props) {
  const dynamicTextRef = useRef<string>("");
  const { isModalOpened, closeModal, openModal } = useModal();
  const {
    isModalOpened: isConfirmModalOpened,
    closeModal: closeConfirmModal,
    openModal: openConfirmModal,
  } = useModal();
  const [text, setText] = useState("");
  const [currentDynamic, setCurrentDynamic] = useState<number>();
  const userData = useAppSelector(s => s.user.user)
  const [customTemplateState, setCustomTemplateState] = useState(true);

  const dynamics = useMemo(() => {
    return data
      .map((c) => c.content_dynamics)
      .filter((c, i, self) => self.indexOf(c) === i)
      .sort((a, b) => a - b);
  }, [data]);

  useEffect(() => {
    setCurrentDynamic(dynamics[0]);
  }, [dynamics]);

  useEffect(() => {
    if (userData && ( userData?.subscription_status === 'trialing' ||  userData?.subscription_status === 'active')) {
      setCustomTemplateState(true)
    }
    else {
      setCustomTemplateState(false)
    }
  }, [userData])

  useEffect(() => {
    updateEditedContent(text);
  }, [text]);

  useEffect(() => {
    if (currentDynamic !== undefined) {
      dynamicTextRef.current = data
        .filter((v) => v.content_dynamics <= currentDynamic)
        .map((v) => v.content)
        .join("");

      setText(dynamicTextRef.current);
    }
  }, [currentDynamic, data]);

  const generateDynamic = () => {
    if (currentDynamic === undefined) return;
    const currentIndex = dynamics.indexOf(currentDynamic);
    if (dynamics[currentIndex + 1]) {
      setCurrentDynamic(dynamics[currentIndex + 1]);
    } else {
      setCurrentDynamic(dynamics[0]);
    }
  };

  if (currentDynamic === undefined) return null;

  return (
    <div>
      <div className="mb-4 pb-2">
        <PostBox
          className="mx-auto"
          category={category}
          initialText={""}
          externalControl={{
            value: text,
            setValue: setText,
          }}
          btns={
            <>
              <div className="col">
                <button className="btn btn--outline" onClick={onClickStartOver}>
                  Start Over
                </button>
              </div>
              <div className="col">
              <button className="btn btn--outline" disabled={!customTemplateState} onClick={onClickCustomTemplates}>
                Custom Templates
              </button>
            </div>
            </>
          }
          editable
          copyBtn={false}
        />
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <button
          className="Creator__back p-0 bg-transparent border-0 fw-bold text--primary"
          onClick={onClickBack}
        >
          <ArrowLeft className="me-2" />
          Back
        </button>
        <div className="d-flex align-items-center">
          <button className="btn" type="submit" onClick={() => {}} disabled>
            Auto-Publish
          </button>
          <button
            className="btn ms-4"
            type="submit"
            onClick={() => {
              copy(text);
              openModal();
            }}
          >
            Finish & Save
          </button>
        </div>
      </div>
      <Modal isOpened={isModalOpened} closeModal={closeModal}>
        <ModalTitle className="fw-bold text-center text-dark mb-2">
          You’re All Set!
        </ModalTitle>
        <div className="text-dark text-center mb-5">
          The article has been copied to your computer’s clipboard.
        </div>
        <div className="text-center mt-n2">
          <button
            style={{
              width: 184,
            }}
            className="btn btn--orange"
            onClick={() => {
              closeModal();
              onClickFinish();
            }}
          >
            Finish
          </button>
        </div>
      </Modal>
      <Modal isOpened={isConfirmModalOpened} closeModal={closeConfirmModal}>
        <ModalTitle className="fw-bold text-center text-dark mb-2">
          Are you sure?
        </ModalTitle>
        <div className="text-dark text-center mb-5">
          Changing content dynamics now will erase your edits. To preserve your
          edits, click the X.”
        </div>
        <div className="text-center mt-n2">
          <button
            style={{
              width: 184,
            }}
            className="btn btn--orange"
            onClick={generateDynamic}
          >
            Yes, I’m sure
          </button>
        </div>
      </Modal>
    </div>
  );
}

const ModalTitle = styled.div`
  font-size: 32px;
  line-height: 48px;
`;
